import React from "react"
import { AppBar, Toolbar, Typography, Link } from "@mui/material"
import { Divider } from "@mui/material"
import Stack from "@mui/material/Stack"

const Footer = () => (
	<div className="footer">
		<p></p>
		<Divider />
		<p></p>

		<AppBar position="static" elevation={0} component="footer" color="default">
			<Typography>
				This Web App is fully responsive. Made in{" "}
				<Link href="https://reactjs.org/" target="_blank">
					ReactJS
				</Link>
				, using{" "}
				<Link href="https://material-ui.com" target="_blank">
					Material-UI
				</Link>{" "}
				and{" "}
				<Link href="https://stripe.com/docs/stripe-js/react" target="_blank">
					React Stripe
				</Link>
				. It's given free of use by{" "}
				<Link href="https://angeloron.com" target="_blank">
					Ange loron
				</Link>
				. react-material-ui-stripe-payment is under the MIT license and can be
				dowloaded{" "}
				<Link
					href="https://gitlab.com/angeloron/react-material-ui-stripe-payment"
					target="_blank"
				>
					here
				</Link>
				.
			</Typography>
			<Toolbar style={{ justifyContent: "center" }}>
				<Stack>
					<Typography variant="caption">Fernando Moreno © 2022</Typography>
					<Typography variant="caption">Collaborators:</Typography>
					<Typography variant="caption">Guillermo Cernuda</Typography>
					<Typography variant="caption">Mercedes Antón</Typography>
				</Stack>
			</Toolbar>
		</AppBar>
	</div>
)

export default Footer
